import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import VaultedPaymentMethod from '../vaultedPaymentMethod.mdx';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Delete a vaulted payment method by id for the `}<inlineCode parentName="p">{`customerId`}</inlineCode>{` attached to the `}<a parentName="p" {...{
        "href": "https://primer.io/docs/api/api-reference/client-session-api/create-client-side-token#request.body.customerId"
      }}>{`client session`}</a>{`.`}</p>
    <p>{`You can get the id from any instance of `}<a parentName="p" {...{
        "href": "/docs/sdk/web/2.x.x/primer-headless-checkout/vaultedPaymentMethod"
      }}>{`VaultedPaymentMethod`}</a>{` returned by `}<a parentName="p" {...{
        "href": "#headlessvaultmanager.deleteVaultedPaymentMethod"
      }}>{`fetchVaultedPaymentMethods`}</a>{`.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`// Initialise Headless Checkout ...

const vaultManager = headless.createVaultManager()
const vaultedPaymentMethods = await vaultManager.fetchVaultedPaymentMethods()
// Delete the first vaulted payment method
try {
    await vaultManager.deleteVaultedPaymentMethod(vaultedPaymentMethods[0]?.id)
} catch (error) {
    // handle errors
}
`}</code></pre>
    <p>{`Throws an error if the id passed does not match any payment method previously retrieved by `}<a parentName="p" {...{
        "href": "#headlessvaultmanager.deleteVaultedPaymentMethod"
      }}>{`fetchVaultedPaymentMethods`}</a>{`.`}</p>
    <p>{`Throws an error if the call to delete the vaulted payment method fails.`}</p>
    <VaultedPaymentMethod mdxType="VaultedPaymentMethod" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      